import React, { useState } from 'react'
import { DateTime } from 'luxon'

import './styles.scss'
import CalendarButton from './CalendarButton'
import ModalWrapper from 'components/ModalWrapper'
import CalendarPicker from 'components/CalendarPicker'
import TimePicker from 'components/TimePicker'
import { lang } from 'utils/helpers'

const ScheduleMsgModal = ({ isOpen, toggle, defaultValue, onSchedule, isSubmitting, errorText }) => {
  const [isOpenCalendarPicker, setIsOpenCalendarPicker] = useState(false)
  const [isOpenTimePicker, setIsOpenTimePicker] = useState(false)
  const [date, setDate] = useState(defaultValue?.date || '')
  const [time, setTime] = useState(defaultValue?.time || '')
  const [error, setError] = useState('')

  const toggleCalendarPicker = () => setIsOpenCalendarPicker(prevState => !prevState)
  const toggleTimePicker = () => setIsOpenTimePicker(prevState => !prevState)

  const handleOnSchedule = () => {
    if (error) setError('')
    const iso = DateTime.fromFormat(`${date} ${time}`, 'yyyy-MM-dd HH:mm:ss').toUTC().toString()
    if (!iso) {
      setError(lang('dashboard_must-set-date-sending-message'))
      return
    }
    onSchedule ({ date, time, iso })
  }

  return (
    <ModalWrapper
      contentClassName='schedule-msg-modal'
      isOpen={isOpen}
      toggle={toggle}
      header={lang('dashboard_schedule')}
      body={
        <div className='schedule-msg-modal__content'>
          <CalendarButton
            label={`${lang('dashboard_send-message-on')}...`}
            text={date || lang('dashboard_select')}
            iconName='icon-calendar-grey'
            onClick={toggleCalendarPicker}
          />
          <CalendarButton
            label={`${lang('dashboard_time_at')}...`}
            text={time || lang('dashboard_select')}
            iconName='icon-clock-grey'
            onClick={toggleTimePicker}
          />
          {isOpenCalendarPicker ? (
            <CalendarPicker
              mode='modal'
              onChange={dates => setDate(dates?.[0] || '')}
              modalOptions={{
                isOpen: isOpenCalendarPicker,
                toggle: toggleCalendarPicker,
                header: {
                  title: lang('dashboard_schedule-date'),
                  subtitle: lang('dashboard_choose-schedule-date-sending-message')
                },
                buttons: true
              }}
            />
          ) : null}
          {isOpenTimePicker ? (
            <TimePicker
              mode='modal'
              modalOptions={{
                isOpen: isOpenTimePicker,
                toggle: toggleTimePicker,
                title: lang('dashboard_schedule-time'),
                legend: lang('dashboard_choose-schedule-time-sending-message')
              }}
              onChange={setTime}
            />
          ) : null}
        </div>
      }
      eventBtnTxt={lang('dashboard_schedule')}
      eventBtn={handleOnSchedule}
      cancelBtnTxt={lang('buttons_cancel')}
      cancelBtn={toggle}
      isSubmitting={isSubmitting}
      error={error || errorText}
    />
  )
}

export default ScheduleMsgModal
